<div class="glow-pill">
    {{content}}
</div>